// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { translate } from '@tectonics/translate';
import { useIsMobileBasedOnScreenWidth } from '@tectonics/hooks';
import { useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getOneClickCardOrCry } from '@tectonics/prs/one-click-card';
import { SelectedCardBrandProvider } from '@tectonics/look-and-feel/commons/selected-card-brand';
import { formatOneClickCardInfoLabel } from '../commons/format-one-click-card-label';
import { CardIcon } from '../card-form/fields/card-icon';
import { FieldCardSecurityCode } from '../card-form/fields/field-card-security-code';

export function OneClickForm(): Node {
  const isMobile = useIsMobileBasedOnScreenWidth();
  const incomingPayment = useOpenedIncomingPayment();
  const oneClickCard = getOneClickCardOrCry(incomingPayment);

  return (
    <SelectedCardBrandProvider cardBrand={oneClickCard.brand}>
      <Root isMobile={isMobile}>
        <OneClickCardInfo />
        <FieldCardSecurityCode />
      </Root>
    </SelectedCardBrandProvider>
  );
}

const Root = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: dense;

  & > :first-child {
    grid-column: ${({ isMobile }) => isMobile ? '1/3' : '1/2'};
  }

  & > :last-child {
    grid-column: ${({ isMobile }) => isMobile ? '1/3' : '2/3'};
  }
`;

function OneClickCardInfo(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const oneClickCard = getOneClickCardOrCry(incomingPayment);

  return (
    <CardInfoWrapper>
      <label>
        {translate('volcanes.fieldCardNumber')}
      </label>

      <CardInfoMessage>
        <CardIcon brand={oneClickCard.brand} />
        <span>
          {formatOneClickCardInfoLabel(oneClickCard)}
        </span>
      </CardInfoMessage>
    </CardInfoWrapper>
  );
}

const CardInfoWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

const CardInfoMessage = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 100%;

  span {
    margin-left: 12px;
  }
`;
